import React from "react";
import { Container, Row, Col, Card, ListGroup, Button, Image, Table } from "react-bootstrap";
import { FaFacebook, FaTiktok, FaYoutube, FaInstagram, FaComment, FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { useState } from "react";
import Footer from './footer';
import { motion } from "framer-motion";
import LatestUpdates from "./latestupdates";
import "./img.css";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";




const ContentSection = () => (
    <Container className="mt-4">
        <Row>
            <Col md={8}>
                <h2 className="text-center">Study In Canada</h2>
                <br /><br />
                <h4 className="fw-bold text-decoration-underline">Application Process , College , Course and University:</h4>
                <p className="mt-3">
                    Home of some of the most respectable universities and colleges, Canada is the top study destination
                    for Indian students. Canada’s study, work, and immigrant advantages attract tens of thousands of
                    international students not only from India but around the world every year. More than 642,480
                    students choose Canada for higher studies in 2019. The country is also known for its diverse
                    culture and majestic sceneries and has been ranked number one for Quality of Life by USNEWS.
                    Also, it holds the 2nd position in overall rankings that includes factors like Adventure,
                    Citizenship, Cultural Influence, Business, etc.</p>
                <p className="mt-3">According to the Organization for Economic Cooperation and Development
                    (OECD), Canada spends more per capita on its Education System than any other country.
                    Canadian Institutes with the first-class infrastructure offer easy access to a wide
                    variety of technology as Canada is a safe country for pursuing education. Canada is
                    famous for its education system. Canadian degrees are considered equivalent to the
                    degrees from the US, Australia, and other Europe countries.</p><br />
                <h4 className="fw-bold text-decoration-underline">Study Direct Stream (SDS):</h4>
                <p className="mt-3">The Student Direct Stream (SDS) is a fast track student visa process
                    that allows students of some countries, including India, to apply in a simplified manner
                    at Canadian post-secondary designated learning institutes. If the student meets all the
                    requirements, then he may get his or her visa within 20 days.</p>
                <p className="mt-3"><b>Benefits of SDS program:</b></p>
                <ul>
                    <li>SDS is a fast track system.</li>
                    <li>SDS program has reduced the document requirements.</li>
                    <li>Many options are available to choose the desired College.</li>

                </ul><br /><br />

                <h4 className="fw-bold text-decoration-underline">Why Study in Canada ?</h4>
                <p className="mt-3">A vast number of courses with a practical approach makes Canada an
                    excellent destination to study abroad. The foremost goal of the Canadian Education System
                    is to make students successful in every aspect of life.</p>
                <p className="mt-3">International Students holding a Canadian degree can work across the globe in highly
                    reputed organizations. Many degrees and diploma programs are available for students
                    from different countries in Canadian academic institutes.</p>
                <p className="mt-3">International students can continue Education in Canada’s top Universities because
                    of the reasonable fee structure as compared to other nations. Canadian degrees are well-reputed.
                    Students can also work while studying to benefit from internship opportunities. Moreover, there are
                    a considerable number of benefits of studying in Canada.</p>
                <ul>
                    <li><b>Multicultural Society: </b>Students from different pAATs of the world are studying in Canadian Institutes,
                        which is one of the main attractions of Canadian Institutes. Toronto and Ontario are declared as the best International
                        cities by Fortune Magazine.</li>
                    <li><b>Canadian Lifestyle: </b>Canada is the best place to live in the world, according to the UN survey. Canada
                        is ranked number one for the past 9 consecutive years. Canada gets a high score because of its high-quality Education
                        System, less crime rate, less violence, reasonable living costs, etc.</li>
                    <li><b>Work Opportunities: </b>Students can work pAAT-time in Canada during their academic course by which
                        they can be able to pay their daily expenses. The maximum duration of pAAT-time work is 20 hours/week. Where
                        students who have opted co-op program can work full time.</li>
                    <li><b>Living standard: </b>International students usually get fascinated by the living style of Canadians because
                        they have one of the highest living standards. Major cities in Canada have a variety of shopping centers, AAT centers,
                        restaurants, Colleges, Universities, etc. Moreover, post-secondary campuses of Canada are equipped with the latest technology.</li>
                    <li><b>Reasonable expenses: </b>The inflation rate of Canada is very low as compared to industrial countries in the past three years.
                        Tuition fees for international students in Canada is much lower than their counterpAATs in competing countries. Moreover, the
                        educational quality of Canadian Institutes is excellent and affordable. So, admissions in Canadian institutes are more competitive
                        for Students from different nations.</li>
                    <li><b>Research Value :</b>Research plays a vital role in acquiring advanced knowledge. Canadian universities run many
                        scholarship programs to encourage talented students. Moreover, depending upon the research topic, The Canadian Government
                        and private business entities may offer to cover the entire cost of the research, which makes it more appealing to
                        study in Canada.</li>
                </ul>
                <br />
                <h4 className="fw-bold text-decoration-underline">Eligibility and Requirements :</h4>
                <p className="mt-3">Depending on your citizenship or where you live, you may need a temporary resident visa as well as a study permit. You must
                    submit your application to the visa office that is responsible for the country or region where you live. A Canada study permit is a document
                    that is issue by Canadian Govt. which allows foreign nationals to study at designated learning institutions (DLI) in Canada. Students have to
                    meet several requirements for getting admission in Canadian Colleges or Universities. Students must have an offer letter of the College/University
                    before applying for a study permit. Moreover, students must have an IELTS scorecard with a minimum of 6 bands overall. Some documents are also
                    required for the Canadian Visa process.</p>
                <h4>TO STUDY IN CANADA YOU MUST FOLLOW THESE CRITERIA:</h4>
                <ul>
                    <li>You must have been accepted by a school, college, university or other educational institution in Canada.</li>
                    <li>You have a valid passport or travel document.</li>
                    <li>You must prove that you have enough money to pay for your:</li>
                    <ul>
                        <li>Tuition Fees;</li>
                        <li>Living Expenses for yourself and any family members who will accompany you to Canada;</li>
                        <li>Return Transportation for yourself and any family members who accompany you to Canada.</li>
                    </ul>
                    <li>You must be a law-abiding citizen with no criminal record and not be a risk to the security of Canada.
                        You may have to provide a police certificate.</li>
                    <li>You must be in good health and willing to complete a medical examination, if necessary.</li>
                    <li>You must satisfy an immigration officer that you will leave Canada when you have completed your studies.</li>
                    <li>You have to furnish certain documents that you will need to apply for a study permit. Like, your credentials,
                        your IELTS result and your course selection etc</li>
                </ul><br />
                <h4 className="fw-bold text-decoration-underline">How to Apply ?</h4>
                <p className="mt-3">Students must have a Canadian Study Permit in order to study in Canada. the application can be applied online or through a paper application. The paper application can be obtained from the citizenship and immigration Canada (CIC) website. But it is recommendable to check the processing time in advance as paper applications typically take about twice as long.</p>

                <p className="mt-3">
                    Here is the process for obtaining a Canadian Student Visa:
                </p>
                <ul>
                    <li><b>Check the processing time: </b>The procedure of visa application usually takes 3-4 weeks. So, students must go through the Canadian consulate website to know the approximate time required for the process of student visa. Always remember, the time shown on the website is just an estimate, not a guarantee.</li>
                    <li><b>Determine your way to apply:</b>There are two ways to apply for Student Visa.</li>
                    <ul>
                        <li><b>Online:</b>Students must have access to a scanner or camera to generate a copy of your documents for uploading and a valid credit card for fee payment for applying for a visa online.</li>
                        <li><b>In person: </b>Download the application form after reading the instructions carefully. Complete your application form with the help of these instructions.</li>
                    </ul>
                    <li>Fill a consent form to get the full assistance Visa Filing Process. You can get the help of consultants for this process.</li>
                    <li><b>Pay Processing Fee: </b>Visa fees, in addition to embassy charges, must be paid to complete the application process. This processing fee is non-refundable. Moreover, if your spouse/common-law pAATner/children are accompanying you on your temporary visa, then appropriate processing fees must be paid for them.</li>
                    <li><b>Submit your application: </b>After processing fee, submission of application form is a must. The student will receive a receipt containing a unique tracking number.</li>
                    <li>After successful approval of your visa application, candidates will receive a notification requesting a passport by the Canadian Government. Students should not worry about their visa process. Pyramid provides proper guidance about the application process.</li>
                </ul><br />
                <h4 className="fw-bold text-decoration-underline">Work While Study in Canada:</h4>
                <p className="mt-3">International Students can work in Canada during their studies and earn enough to pay their daily expenses. Permission of working hours is different according to the type of course. Usually, students can work up to 20 hours per week during the course and can work full time during the vacations. There are an ample number of Colleges and Universities which offer Co-op/internship programs to the students.
                </p>
                <ul>
                    <li><b>Working off-campus: </b>Students have permission to work while studying for 20 hours a week during academic sessions. They are allowed to work full time in their scheduled breaks.</li>
                    <li><b>Working On-campus:</b>Students having valid study permits are eligible to work on-campus at the Canadian institutions.</li>
                    <li><b>Co-op/ internships:</b>These programs are available for such International students, for whom practical work experience is an essential pAAT of their study program.</li>
                </ul><br />
                <p className="mt-3">There are other visa options available for applicants. contact us  , Book an Appointment or enquire with the form below , to check are you eligible for Canada Student visa or any other Visa.  </p>
                <br />


            </Col>

            {/* Sidebar Section */}
            <Col md={4}>
                <Card className="p-3 text-center">
                    {/* Bajwa Immigration Image */}
                    <Image
                        src="./img/brand-logo.png"
                        alt="Bajwa Immigration Logo"
                        fluid
                        className="mb-3"
                    />

                    <h6 className="fw-bold">Subscribe to our YouTube channel</h6>
                    <Button variant="danger" className="mb-3"><a href="https://www.youtube.com/embed/uOGAB9oYets">SUBSCRIBE</a></Button>

                    <h6 className="fw-bold">Book Consultation</h6>
                    <Button variant="warning">BOOK CONSULTATION</Button>

                    <h6 className="fw-bold mt-3">Like Us on Facebook !!</h6>
                    {/* Facebook Embed */}
                    <iframe
                        src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FBajwaImmigration&tabs&width=340&height=130&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
                        width="100%"
                        height="130"
                        style={{ border: "none", overflow: "hidden" }}
                        scrolling="no"
                        frameBorder="0"
                        allowFullScreen
                    ></iframe>

                    {/* Social Media */}
                    <h6 className="fw-bold mt-3">We are also on:</h6>
                    <div className="d-flex justify-content-center gap-3">
                        <FaInstagram size={30} color="#C13584" />
                        <FaTiktok size={30} color="#000" />
                        <FaYoutube size={30} color="crimson" />
                    </div>
                </Card>
            </Col>
        </Row>
    </Container>
);


const CanadaVisa = () => {
    return (
        <>
            <Container className="mt-4">
                <h1 className="fw-bold">Canada Student Visa</h1>

                {/* YouTube Embed Section */}
                <Row className="mt-3">
                    <Col md={8}>
                        <div className="ratio ratio-16x9">
                            <iframe
                                width="100%"
                                height="400"
                                src="https://www.youtube.com/embed/ODEfwbsDl_E"
                                title="YouTube video"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </Col>

                    {/* Sidebar - Latest Posts */}
                    <Col md={4}>
                        <Card>
                            <Card.Header className="fw-bold">Latest Posts</Card.Header>
                            <ListGroup variant="flush">
                                <ListGroup.Item><Link to="/professional" className="dropdown-item"> <a href="" className="text-decoration-none">Professional Year</a> </Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/coursechange" className="dropdown-item"> <a href="" className="text-decoration-none">Admissions And Course Change </a></Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/skilledID" className="dropdown-item"> <a href="" className="text-decoration-none">   Skilled Independent Visa (Subclass 189)</a></Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/workregionalvisa" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Work Regional Visa (Subclass 491)</a></Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/nominatedvisa" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Nominated Visa (Subclass 190)</a></Link></ListGroup.Item>
                                 <ListGroup.Item><a href="https://immi.homeaffairs.gov.au/visas/getting-a-visa/visa-listing/skilled-regional-191"
                                    className="dropdown-item text-decoration-none"
                                    style={{ color: "#22327f" }}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    Permanent Residence visa (Subclass 191)
                                  </a>
                                </ListGroup.Item>
                                {/* <ListGroup.Item><Link to="/regionalvisa" className="dropdown-item"><a href="" className="text-decoration-none">Skilled Regional Visa (Subclass 887)</a></Link></ListGroup.Item> */}
                                <ListGroup.Item><Link to="/tempactivity" className="dropdown-item"><a href="" className="text-decoration-none">Temporary Activity Visa (Subclass 408)</a></Link></ListGroup.Item>
                            </ListGroup>
                        </Card>
                    </Col>
                </Row>
            </Container>

            {/* Content Section */}
            <ContentSection />


            {/* Floating Feedback Button */}
            <div className="position-fixed bottom-0 stAAT-0 m-3">
            <motion.button
    initial={{ x: "-100vw", opacity: 0 }}
    animate={{ x: 0, opacity: 1 }}
    transition={{ type: "tween", duration: 0.6, ease: "easeOut" }}
    className="btn btn-danger btn-sm position-fixed bottom-0 stAAT-0 m-3"
    style={{ zIndex: 1050 }}
>
    <i className="bi bi-chat-left-text me-1"></i>
    <a 
        href="https://au.bajwaimmigration.com/book-appointment" 
        className="text-white text-decoration-none"
    >
        Consult Now
    </a>
</motion.button>
            </div>
           
            <br />
           
            <LatestUpdates />
            <Footer />
        </>
    );
};

export default CanadaVisa;
